import React, { useEffect, useState } from 'react'
import Select from 'react-select'

type Option = {
  value: string
  label: string
}
export type CustomSelectProps = {
  name: string
  options: Option[] | string
}

function CustomSelect({ name, options }: CustomSelectProps) {
  const [selected, setSelected] = useState<Option | null>(null)
  const [stateOptions, setStateOptions] = useState<Option[]>([])
  const isOption = (value: unknown): value is Option => {
    if (!value || typeof value !== 'object' || Array.isArray(value)) {
      return false
    }

    const option = value as { value?: unknown; label?: unknown }
    return typeof option.value === 'string' && typeof option.label === 'string'
  }

  useEffect(() => {
    try {
      setStateOptions(
        typeof options === 'string'
          ? (JSON.parse(options) as Option[])
          : options,
      )
    } catch (error) {
      console.error(error)
    }
  }, [options])

  return (
    <div className="SelectControl">
      <input type="hidden" value={selected?.value} name={name} />
      <Select
        classNamePrefix="SelectControl"
        value={selected}
        onChange={(newValue: unknown) => {
          setSelected(isOption(newValue) ? newValue : null)
        }}
        isClearable={false}
        isSearchable={false}
        options={stateOptions}
      />
    </div>
  )
}

export default CustomSelect
